// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__85rvM","content":"RecentSearches_content__3WF7a"};